import React, { createContext, useContext } from "react";
import { CriteriaStatement } from "./criteria-tree-builder-types";

/** All user-facing strings for the criteria tree builder UI. */
export interface CriteriaTreeBuilderLabels {
  addCondition: string;
  addNestedGroup: string;
  removeCondition: string;
  removeGroup: string;
}

/** Default user-facing strings for the criteria tree builder UI. */
export const DEFAULT_CRITERIA_TREE_BUILDER_LABELS: CriteriaTreeBuilderLabels = {
  addCondition: "+ Add Condition",
  addNestedGroup: "+ Add Nested Group",
  removeCondition: "Remove condition",
  removeGroup: "Remove group",
};

export interface CriteriaTreeBuilderRenderStatementInputArgs {
  statement: CriteriaStatement;
  onStatementChange: (value: string) => void;
}

export interface CriteriaTreeBuilderInternalConfig {
  disabled: boolean;
  labels: CriteriaTreeBuilderLabels;
  allowNestedGroups: boolean;
  maxNestingDepth: number | undefined;
  renderStatementInput: (
    args: CriteriaTreeBuilderRenderStatementInputArgs,
  ) => React.ReactNode;
}

const CriteriaTreeBuilderContext = createContext<CriteriaTreeBuilderInternalConfig | null>(
  null,
);

/** Internal context shared by the group/statement sub-components. Not for public use. */
export const CriteriaTreeBuilderCtx = CriteriaTreeBuilderContext;

/** Internal hook to read the shared config. Not for public use. */
export function useCriteriaTreeBuilderContext(): CriteriaTreeBuilderInternalConfig {
  const ctx = useContext(CriteriaTreeBuilderContext);
  if (!ctx) {
    throw new Error(
      "CriteriaTreeBuilder sub-components must be rendered inside <CriteriaTreeBuilder />.",
    );
  }
  return ctx;
}